export const chemicalResult = {
    0: '0 - No Available Data',
    1: '1 - No Effect (Excellent)',
    2: '2 - Minor Effect (Good)',
    3: '3 - Some Effect (Poor)',
    4: '4 - Strong Effect (Not Recommended)'
}
